import http from "./httpService";
import configdata from "./config.json";
let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
  apiEndpoint = `${configdata.apiUrl}/detectors`;
} else {
  apiEndpoint = `${configdata.herokuUrl}/detectors`;
}

export async function  generateAIImage(prompt, artStyle) {
  const response = await http.post(`${apiEndpoint}/ai_generative_image`, {
    prompt : prompt,
    artStyle : artStyle
  });
  return response;
}


export async function aiSmartDesk(message, quickPrompt = "") {
  const response = await http.post(`${apiEndpoint}/ai_smartdesk`, {
    message,
    quickPrompt,
  });
  return response;
}

export async function aiHumanizer(text, level = "balanced") {
  const response = await http.post(`${apiEndpoint}/ai_humanizer`, {
    text,
    level,
  });
  return response;
}

export default {
  aiSmartDesk,
  aiHumanizer,
};
